import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { NeoTipoPeriodicidadDTO } from '../Model/neoTipoPeriodicidadDTO';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

const API_URL=environment.apiLocalUrl+'neoTipoPeriodicidad';
@Injectable({
  providedIn:'root'
})
export class TipoPeriodicidadService {

  constructor(private _http: HttpClient) { }

  getTiposPeriodicidad(): Observable<NeoTipoPeriodicidadDTO[]>{
    return this._http.get<NeoTipoPeriodicidadDTO[]>(API_URL).pipe(catchError(HandleHttpError));
  }
}
